import AgreementSummaries from './AgreementSummaries';

export default AgreementSummaries;